var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_-_Sorting",
    width: 24,
    height: 24,
    "data-name": "Icon - Sorting",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;opacity:0}.cls-2{fill:none;stroke:#0baf50;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.5px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Frame",
    d: "M0 0H24V24H0z",
    className: "cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Sort",
    "data-name": "Icon - Sort"
  }, /*#__PURE__*/React.createElement("path", {
    id: "frame-2",
    d: "M0 0h22v16H0z",
    className: "cls-1",
    "data-name": "frame",
    transform: "translate(1 4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_104",
    d: "M0 0L0 13",
    className: "cls-2",
    "data-name": "Line 104",
    transform: "translate(4.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_105",
    d: "M4 0L0 4",
    className: "cls-2",
    "data-name": "Line 105",
    transform: "translate(.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_106",
    d: "M0 0L4 4",
    className: "cls-2",
    "data-name": "Line 106",
    transform: "translate(4.5 1.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_107",
    d: "M0 0L0 13",
    className: "cls-2",
    "data-name": "Line 107",
    transform: "translate(11.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_108",
    d: "M4 4L0 0",
    className: "cls-2",
    "data-name": "Line 108",
    transform: "translate(7.5 10.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_109",
    d: "M0 4L4 0",
    className: "cls-2",
    "data-name": "Line 109",
    transform: "translate(11.5 10.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSorting);
export default __webpack_public_path__ + "static/media/icon-sorting.50e27c6436e88f9b2b49e955177cb446.svg";
export { ForwardRef as ReactComponent };